import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import "./UserList.css" 

const SubSubCategoryList = () => {
    document.title = "Sub Sub Categorys | Uma Classes";

    const [subSubCategorys, setSubSubCategorys] = useState([]);
    const [modal, setModal] = useState(false);
    const [CategoryIdToDelete, setCategoryIdToDelete] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSubSubCategorys = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get('https://uma.aasmo.in/api/admin/getall-subsubcategory', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setSubSubCategorys(response || []);
            } catch (error) {
                console.error('Error fetching Sub Sub Categorys:', error);
            }
        };

        fetchSubSubCategorys();
    }, []);

    const toggleModal = () => setModal(!modal);

    const handleDelete = (CategoryId) => {
        setCategoryIdToDelete(CategoryId);
        toggleModal();
    };

    const confirmDelete = async () => {
        try {
            const token = localStorage.getItem('token');
            await axios.delete(`https://uma.aasmo.in/api/admin/delete-subsubcategory/${CategoryIdToDelete}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setSubSubCategorys(subSubCategorys.filter(Category => Category._id !== CategoryIdToDelete));
            toggleModal();
        } catch (error) {
            console.error('Error deleting Category:', error);
        }
    };

    const handleEdit = (CategoryId) => {
        navigate(`/edit-subsubcategory/${CategoryId}`);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="Courses" breadcrumbItem="All" />

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <h4 className="card-title">All Sub Sub Categorys</h4>
                                    <p className="card-title-desc">Below are all Sub Sub Categorys</p>

                                    <div className="table-responsive">
                                        <table className="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Category Name</th>
                                                    <th>Sub Category Name</th>
                                                    <th>Sub Sub Category Name</th>
                                                    <th>Date</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {subSubCategorys.length > 0 ? (
                                                    subSubCategorys.map((Category, index) => (
                                                        <tr key={Category._id}>
                                                            <th scope="row">{index + 1}</th>
                                                            <td className="nowrap">{Category?.subcategory?.category?.name || "N/A"}</td>
                                                            <td className="nowrap">{Category?.subcategory?.name || "N/A"}</td>
                                                            <td className="nowrap">{Category?.name || "N/A"}</td>

                                                            <td className="nowrap">{moment(Category.createdAt).format('MMMM Do, YYYY')}</td>

                                                            <td>
                                                                <i className="dripicons-document-edit" onClick={() => handleEdit(Category._id)} />{" "}
                                                                <i className="dripicons-document-delete" onClick={() => handleDelete(Category._id)} />{" "}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="10" className="text-center">No Sub Categorys found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>

                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                {/* Delete Confirmation Modal */}
                <Modal isOpen={modal} toggle={toggleModal}>
                    <ModalHeader toggle={toggleModal}>Confirm Deletion</ModalHeader>
                    <ModalBody>
                        Are you sure you want to delete this Category?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                        <Button color="danger" onClick={confirmDelete}>Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </React.Fragment>
    );
};

export default SubSubCategoryList;
